<template>
  <div class="pause-serve-header">
    <div><logo-in-header :link-to-home="false" :color="'white'"
                         :box-height="1" :font-size="1.7" class="pause-serve-logo"></logo-in-header></div>
  </div>
</template>

<script>
  import LogoInHeader from '../logoInHeader/LogoInHeader.vue'

  export default {
    name: 'pause-serve-header',
    components: {LogoInHeader}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/mixins/gradient";

  .pause-serve-header {
    @include gradient-background($deg: 90deg, $bottom-color: #416CF8 0%, $top-color: #EC55FF 100%);
    box-shadow: 0 1px 0 0 rgba(0,0,0,0.10);
    height: 1rem;
    line-height: 1rem;
    display: inline-block;
    width: 100vw;
    letter-spacing: .47px;
    font-size: .2rem;
    color: #fff;
    vertical-align: middle;
    text-align: center;
  }

  .pause-serve-logo {
    width: 1.7rem;
    text-align: center;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// pauseServerHeader.vue?1028fd68